import { isUserLogged } from "./user";

export function launchModalOrRedirect (search) {
  if (!isUserLogged) {
    sessionStorage.setItem("royaltyFreeImagesSearch", search ? `marketplace/?s=${search}` : 'marketplace/');
    document.querySelector('[data-toggle="login-modal"]').click();
  } else {
    search
    ? window.location.href = `https://desygner.com/create/marketplace/?s=${search}`
    : window.location.href = `https://desygner.com/create/marketplace/`
  }
}
